import { render, staticRenderFns } from "./PostFileThumbnail.vue?vue&type=template&id=517426cb&scoped=true&"
import script from "./PostFileThumbnail.vue?vue&type=script&lang=ts&"
export * from "./PostFileThumbnail.vue?vue&type=script&lang=ts&"
import style0 from "./PostFileThumbnail.vue?vue&type=style&index=0&id=517426cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517426cb",
  null
  
)

export default component.exports